import { StandardFontEmbedder, StandardFonts } from "pdf-lib";

// ENG-2482: the same fit Sign uses on the signed PDF (sign-backend cpDocumentSignaturePdf.service.js
// drawText), with the same Helvetica metrics, so the preview breaks lines where the signed copy does.
const helvetica = StandardFontEmbedder.for(StandardFonts.Helvetica);

function wrapped(text, size, width) {
  const lines = [];
  for (const paragraph of text.split("\n")) {
    let line = "";
    let measured = 0;
    for (const character of paragraph) {
      const characterWidth = helvetica.widthOfTextAtSize(character, size);
      if (characterWidth > width) return null;
      while (line && measured + characterWidth > width) {
        const space = line.lastIndexOf(" ");
        if (space >= 0 && space < line.length - 1) {
          lines.push(line.slice(0, space + 1));
          line = line.slice(space + 1);
          measured = helvetica.widthOfTextAtSize(line, size);
        } else {
          lines.push(line);
          line = "";
          measured = 0;
        }
      }
      line += character;
      measured += characterWidth;
    }
    lines.push(line);
  }
  return lines;
}

// Box size in PDF points. Null when the value can't fit even at 6pt, or Helvetica can't draw it.
export function fitCpText(value, boxWidth, boxHeight) {
  const padding = Math.min(2, boxWidth / 20, boxHeight / 20);
  const width = boxWidth - padding * 2;
  const height = boxHeight - padding * 2;
  try {
    for (let size = 12; size >= 6; size -= 0.5) {
      const lines = wrapped(value, size, width);
      if (lines && helvetica.heightOfFontAtSize(size) + (lines.length - 1) * size * 1.2 <= height) return { size, lines, padding };
    }
  } catch {
    return null;
  }
  return null;
}
